module.exports = __webpack_public_path__ + "img/mace.abf63a24.svg";